export default {
      id: "icon-close-usage",
      viewBox: "0 0 12.728 12.728",
      url: __webpack_public_path__ + "img/icons.svg#icon-close",
      toString: function () {
        return this.url;
      }
    }